// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgPlaySolid = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.25 5.053a1.35 1.35 0 0 1 2.038-1.161l11.723 6.947a1.35 1.35 0 0 1 0 2.322L7.288 20.108a1.35 1.35 0 0 1-2.038-1.161z"
      clipRule="evenodd"
    />
  </svg>
);
export const PlaySolidIcon = forwardRef(SvgPlaySolid);
